import { render } from "./IconText.vue?vue&type=template&id=1aea780a&scoped=true&ts=true"
import script from "./IconText.vue?vue&type=script&lang=ts"
export * from "./IconText.vue?vue&type=script&lang=ts"

import "./IconText.vue?vue&type=style&index=0&id=1aea780a&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aea780a"]])

export default __exports__